/* eslint-disable */
export const all = state => state.all;
export const received = state => state.received;
export const receivedsTotal = state => state.receivedsTotal;
export const sended = state => state.sended;
export const sendedsTotal = state => state.sendedsTotal;
export const wallet = state => state.wallet;
export const page = state => state.page;
export const totalResources = state => state.totalResources;
export const limitOptions = state => state.limitOptions;
export const limit = state => state.limit;
export const loadingData = state => state.loadingData;
export const walletId = state => state.wallet.id;
export const withdraw = state => state.withdraw;
export const withdrawError = state => state.withdrawError;
export const withdrawSuccess = state => state.withdrawSuccess;
export const notificationBar = state => state.notificationBar;
export const showFilters = state => state.showFilters;
// filter and export params
export const filtersId = state => state.filtersId;
export const filtersPositive = state => state.filtersPositive;
export const filtersTypeId = state => state.filtersTypeId;
export const kind = state => state.kind;
export const filtersAmount = state => state.filtersAmount;
export const filtersInitialDate = state => state.filtersInitialDate;
export const filtersOrdination = state => state.filtersOrdination;
export const filtersTransactionType = state => state.filtersTransactionType;
export const filterParams = state => state.filterParams;

export const pagination = state => {
  const page_set = {
    page: state.page,
    rowsPerPage: state.limit,
    totalItems: state.totalResources,
  };
  return page_set;
};
